import styled from 'styled-components';

export const Container = styled.div`
  .action-lock-unlock {
    padding: 12px;
    width: 100%;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .action-lock-unlock-radio {
      padding: 24px 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;

      .anticon {
        font-size: 1.1rem;
        margin: 4px 8px;
      }

      .anticon-lock,
      .anticon-close-circle {
        color: red;
      }
      .anticon-unlock {
        color: green;
      }
    }
  }
`;
